<section class="section-color" id="services">
    <div class="container" style="padding-top: 100px; padding-bottom: 100px;">
        <div class="row fade-bottom" style="position: relative;
        animation-duration: 1000ms;
        transition-timing-function: ease;
        transition-delay: 0ms;">
            <div class="title" style="margin-bottom: 0;">
                <h2 class="text-primary" style="margin: 0;">Software solutions to scale your business</h2>
                <p class="text-secondary">Our services</p>
            </div>
        </div>
        <div class="grid-box3 fade-bottom" style="margin-top: 60px; position: relative;
        animation-duration: 1000ms;
        transition-timing-function: ease;
        transition-delay: 0ms;">
            <div class="grid-item">
                <div class="cnt-box cnt-box-info boxed">
                    <div class="img-box"><img src="assets/image-9.webp" width="800" height="501" alt=""></div>
                    <div class="caption">
                        <h2 class="text-primary">API & Systems Integrations</h2>
                        <p>
                            Your data integration is reliable and effective thanks to our experience with thousands of
                            APIs and platforms.
                        </p>
                    </div>
                </div>
            </div>
            <div class="grid-item">
                <div class="cnt-box cnt-box-info boxed">
                    <div class="img-box"><img src="assets/image-17.webp" width="800" height="500" alt=""></div>
                    <div class="caption">
                        <h2 class="text-primary">Custom Portals & CRMs</h2>
                        <p>
                            There isn't a better way to manage your company's workflow than a specially designed web
                            portal.
                        </p>
                    </div>
                </div>
            </div>
            <div class="grid-item">
                <div class="cnt-box cnt-box-info boxed">
                    <div class="img-box"><img src="assets/image-11.webp" width="800" height="500" alt=""></div>
                    <div class="caption">
                        <h2 class="text-primary">Data Management Apps</h2>
                        <p>
                            Your company can operate efficiently and report on crucial KPIs with the help of custom data
                            management apps.
                        </p>
                    </div>
                </div>
            </div>
            <div class="grid-item">
                <div class="cnt-box cnt-box-info boxed">
                    <div class="img-box"><img src="assets/image-5.webp" width="800" height="500" alt=""></div>
                    <div class="caption">
                        <h2 class="text-primary">Development Partnerships</h2>
                        <p>
                            Your new on-shore partner for software development will effectively meet your daily needs.
                        </p>
                    </div>
                </div>
            </div>
            <div class="grid-item">
                <div class="cnt-box cnt-box-info boxed">
                    <div class="img-box"><img src="assets/image-12.webp" width="800" height="500" alt=""></div>
                    <div class="caption">
                        <h2 class="text-primary">Specialized Software</h2>
                        <p>
                            You've upgraded from your legacy software and none of the big box solutions seem to be a
                            good fit?
                        </p>
                    </div>
                </div>
            </div>
            <div class="grid-item">
                <div class="cnt-box cnt-box-info boxed">
                    <div class="extra-field">30% discount today</div>
                    <div class="img-box"><img src="assets/image-16.webp" width="800" height="500" alt=""></div>
                    <div class="caption">
                        <h2 class="text-primary">Discovery Phase</h2>
                        <p>
                            Each stage of development is made clearer by the project discovery phase, which was
                            completed on time.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
